module.exports = __webpack_public_path__ + "biao12.gif?a09e819";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao12.gif
 ** module id = 47
 ** module chunks = 0
 **/